@if (giftcard) {
<div class="flex flex-justify-between flex-middle">
    <div class="inline-block">
        {{'Gift card' | translate}}&nbsp;({{lastFour}})
        <action class="inline-block m-l-1"
                [status]="status"
                (click)="remove()">
            <span class="cursor-pointer underline">{{'Remove' | translate}}</span>
        </action>
    </div>
    <price class="price"
           [value]="value * -1" />
</div>
}
